import LayoutMain from '@/layouts';

import { routePre } from '@/config'
const pre = 'home_'


export default {
    path: routePre,
    name: 'home',
    redirect: {
        name: `${pre}index`
    },
    component: LayoutMain,
    children: [
        {
            path: routePre + 'index',
             name: `${pre}index`,
            header: 'home',
            meta: {
                title: '小海优品',
                is_navbar: false,
            },
            component: () => import('@/pages/index/index'),
        },
        {
            path: routePre + 'product',
            name: `${pre}product`,
            header: 'home',
            meta: {
                title: '审核结果',
                is_navbar:true,
                leftArrow:false
            },
            component: () => import('@/pages/product/index'),
        },
        {
            path: routePre + 'endpage',
            name: `${pre}endpage`,
            header: 'home',
            meta: {
                title: '温馨提示',
                is_navbar: false
            },
            component: () => import('@/pages/endpage/index'),
        },
        {
            path: routePre + 'channel',
            name: `${pre}channel`,
            header: 'home',
            meta: {
                title: '渠道人员登记',
                is_navbar:true,
                leftArrow:false
            },
            component: () => import('@/pages/channelManner/index'),
        },
        {
        path: routePre + 'agreement/cerService',
            name: `cerService`,
            header: 'home',
            meta: {
                title: '用户授权协议',
                is_navbar: false
            },
            component: () => import('@/pages/agreement/cerService'),
        },
    ],
}

